module.exports = __webpack_public_path__ + "img/KI.2fec9ac4.svg";